<template>
  <v-dialog
    content-class="paymentDialog"
    v-model="isDialog"
    persistent
    style="z-index: 600;"
    max-width="800"
    :light="true"
  >
    <v-card v-if="isDialog" style="min-height: 500px">
      <!--      <div class="absX" @click.passive="cancleDialog">-->
      <!--        <v-icon x-large class="myGray">mdi-window-close</v-icon>-->
      <!--      </div>-->
      <div class="spacer-25"></div>
      <h1 style="padding: 0 24px" class="mt-4 text-center">Zu zahlender Gesamtbetrag:</h1>
      <div class="spacer-40"></div>
      <h1 class="text-center">{{ total | priceTotal }}</h1>
      <v-card-text>
        <div class="spacer-40"></div>
        <div class="spacer-40"></div>
        <div class="text-center">
          <template v-if="terminalInstructions">
            <div class="text-center">
              <div class="blink-border pa-10 ml-5 mr-5 d-inline-block">
                <h2>{{ terminalInstructions }}</h2>
              </div>
            </div>
          </template>
          <template v-else>
            <h2>Bitte bezahle jetzt am Kartenterminal</h2>
          </template>
        </div>

        <div class="mt-10">
          <div class="spacer-40"></div>
          <div class="spacer-40"></div>
          <div class="spacer-40"></div>
          <div class="spacer-40"></div>
          <!--          <div class="superCenter">-->
          <!--            <v-btn-->
          <!--              text-->
          <!--              class="btn-df"-->
          <!--              @click.native.passive="cancleDialog"-->
          <!--            >-->
          <!--              Abbrechen-->
          <!--            </v-btn>-->
          <!--          </div>-->
        </div>
      </v-card-text>

      <!--      <v-card-actions>-->
      <!--&lt;!&ndash;        <v-spacer></v-spacer>&ndash;&gt;-->
      <!--      </v-card-actions>-->

    </v-card>
  </v-dialog>
</template>

<script>
import * as util from '../vendor/util'

export default {
  props: {
    dialog: Boolean,
    total: Number,
    terminalInstructions: String,
  },
  data() {
    return {
      isDialog: false,
    }
  },
  watch: {
    dialog(newValue) {
      this.isDialog = newValue;
      if (newValue) {
      }
    },
    isDialog(newValue) {
      if (!newValue) {
        this.$emit('close');
      }
    }
  },

  methods: {
    cancleDialog() {
      this.isDialog = false;
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
